import type { KeyboardEvent } from "react";

// Arrow-key navigation for a role="radiogroup" of <button role="radio">: the
// arrows move to (and select) the previous / next enabled option, wrapping.
// Pair with tabIndex={selected ? 0 : -1} on each option so Tab enters the group
// once.
export function radioGroupKeyDown(e: KeyboardEvent<HTMLElement>) {
  const step = e.key === "ArrowDown" || e.key === "ArrowRight" ? 1 : e.key === "ArrowUp" || e.key === "ArrowLeft" ? -1 : 0;
  if (!step) return;
  const radios = Array.from(e.currentTarget.querySelectorAll<HTMLButtonElement>('[role="radio"]:not([disabled])'));
  if (!radios.length) return;
  e.preventDefault();
  const current = radios.indexOf(document.activeElement as HTMLButtonElement);
  const next = radios[(current + step + radios.length) % radios.length]!;
  next.focus();
  next.click();
}
